var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "20px",
        height: "20px",
        viewBox: "0 0 20 20",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        fill: "F09A0FFF",
        stroke: "F09A0FFF",
      },
    },
    [
      _c("g", { attrs: { id: "SVGRepo_bgCarrier", "stroke-width": "0" } }),
      _vm._v(" "),
      _c("g", {
        attrs: {
          id: "SVGRepo_tracerCarrier",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
        },
      }),
      _vm._v(" "),
      _c("g", { attrs: { id: "SVGRepo_iconCarrier" } }, [
        _c("title", [_vm._v("file_image [#F09A0FFF]")]),
        _vm._v(" "),
        _c("desc", [_vm._v("Created with Sketch.")]),
        _vm._v(" "),
        _c("defs"),
        _vm._v(" "),
        _c(
          "g",
          {
            attrs: {
              id: "Page-1",
              stroke: "none",
              "stroke-width": "1",
              fill: "none",
              "fill-rule": "evenodd",
            },
          },
          [
            _c(
              "g",
              {
                attrs: {
                  id: "Dribbble-Light-Preview",
                  transform: "translate(-220.000000, -1559.000000)",
                  fill: "#F09A0FFF",
                },
              },
              [
                _c(
                  "g",
                  {
                    attrs: {
                      id: "icons",
                      transform: "translate(56.000000, 160.000000)",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M176,1409.1052 C176,1408.5532 176.448,1408.1052 177,1408.1052 C177.552,1408.1052 178,1408.5532 178,1409.1052 C178,1409.6572 177.552,1410.1052 177,1410.1052 C176.448,1410.1052 176,1409.6572 176,1409.1052 L176,1409.1052 Z M176.75,1412.0532 L180,1416.0002 L168,1416.0002 L172.518,1410.0532 L175.354,1414.1052 L176.75,1412.0532 Z M182,1417.0002 L166,1417.0002 L166,1401.0002 L176,1401.0002 L176,1407.0002 L182,1407.0002 L182,1417.0002 Z M178,1399.0002 L164,1399.0002 L164,1419.0002 L166,1419.0002 L182,1419.0002 L184,1419.0002 L184,1405.1052 L178,1399.0002 Z",
                        id: "file_image-[#F09A0FFF]",
                      },
                    }),
                  ]
                ),
              ]
            ),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }